/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import LinearProgress from '@material-ui/core/LinearProgress';

const localizedErrors = {
  'Username:': 'Nutzer existiert nicht!',
  Wrong: 'Passwort falsch!',
};

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
    };

    this.keyPress = this.keyPress.bind(this);
    this.setUsername = this.setUsername.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.login = this.login.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { errorMessage } = nextProps;
    if (errorMessage) {
      const errorKey = errorMessage.substr(0, errorMessage.indexOf(' '));
      this.props.errorNotification(localizedErrors[errorKey]);
    }
  }

  setUsername(event) {
    this.setState({ username: event.target.value });
  }

  setPassword(event) {
    this.setState({ password: event.target.value });
  }

  keyPress(event) {
    if (event.key === 'Enter') {
      this.login();
      event.preventDefault();
      return false;
    }
    return true;
  }

  login() {
    const { username, password } = this.state;
    if (username && username !== '' && password && password !== '') {
      this.props.login({ userName: username, password });
    } else {
      this.props.errorNotification('Bitte Logindaten eingeben!');
    }
  }

  render() {
    const { classes } = this.props;

    if (this.props.loggedIn) {
      return <Redirect to="/" />;
    }

    const loadingIndicator = this.props.loading
      ? <LinearProgress />
      : null;

    const errorMessage = this.props.errorMessage
      ? (<Typography className={classes.errorMessage}>
        {this.props.errorMessage}
      </Typography>)
      : null;

    return (

      <Paper className={classes.containerStyle}>
        <div>
          <Typography variant="h6" color="inherit" className={classes.header}>
            Login
          </Typography>

          {loadingIndicator}
          {errorMessage}
          <form noValidate onKeyPress={this.keyPress}>
            <div className={classes.emailGroupStyle}>
              <TextField
                className={classes.textBox}
                required
                placeholder="E-Mail "
                value={this.state.username}
                onChange={this.setUsername}
              />
            </div>
            <div className={classes.formGroupStyle}>
              <TextField
                className={classes.textBox}
                required
                type="password"
                placeholder="Passwort"
                autoComplete="current-password"
                value={this.state.password}
                onChange={this.setPassword}
              />
            </div>
            <div className={classes.buttonGroupStyle}>
              <Button
                onClick={this.login}
                color="primary"
                disabled={this.props.loading}
              >Einloggen</Button>
            </div>
          </form>
        </div>
      </Paper>
    );
  }
}

const styles = theme => ({
  header: {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: 10,
  },
  errorMessage: {
    textAlign: 'center',
    background: theme.palette.error.light,
    color: theme.palette.error.contrastText,
    padding: 10,
  },
  formGroupStyle: {
    textAlign: 'center',
    paddingBottom: 15,
  },
  emailGroupStyle: {
    textAlign: 'center',
    padding: '15px 0',
  },
  buttonGroupStyle: {
    textAlign: 'center',
    paddingBottom: 10,
  },
  containerStyle: {
    width: 400,
    margin: '20px auto',
  },
  loggedinMessage: {
    margin: '125px',
  },
  textBox: {
    width: '100%',
    padding: 10,
  },
});

Login.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  login: PropTypes.func.isRequired,
  errorNotification: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  errorMessage: PropTypes.string,
};

Login.defaultProps = {
  errorMessage: null,
};

export default withStyles(styles)(Login);
